module.exports = __webpack_public_path__ + "static/media/wechat_sm.963c7de377a70d10fd66ab65b1c52fb7.svg";